module.exports = __webpack_public_path__ + "static/media/3.83a44060.jpg";